import React from "react";
import "../css/DocumentsAndAcademics.css";

const DocumentsAndAcademics = () => {
  const documentsList = [
    { text: "Mandatory Disclosure Details - CBSE", url: "#" },
    {
      text: "Affiliation Letter and the recent extension of affiliation",
      url: "#",
    },
    {
      text: "Societies/ Trust/ Company Registration/ Renewal Certificate, as applicable",
      url: "#",
    },
    { text: "NOC certificate issued", url: "#" },
    { text: "Recognition certificate under RTE 2009-Grade 1 to 8", url: "#" },
    {
      text: "Valid Building Safety Certificate as per The National Building Code",
      url: "#",
    },
    { text: "Fire Safety Certificate", url: "#" },
    { text: "FRC Fee Approval", url: "#" },
    { text: "DEO Certificate", url: "#" },
    { text: "Water Certificate", url: "#" },
  ];

  const academicsList = [
    { text: "ALMANAC 2024-25", url: "#" },
    { text: "Fee Structure of the Morning Shift", url: "#" },
    { text: "Fee Structure of the Afternoon Shift", url: "#" },
    { text: "List of School Management Committee (SMC)", url: "#" },
    {
      text: "List of Parents Teachers Association (PTA) Morning Shift",
      url: "#",
    },
    {
      text: "List of Parents Teachers Association (PTA) Afternoon Shift",
      url: "#",
    },
  ];

  return (
    <div className="disclosure-wrapper">
      <div className="disclosure-container">
        {}
        <section className="disclosure-section">
          <h2 className="section-title">Documents and Information</h2>
          <ul className="links-list">
            {documentsList.map((doc, index) => (
              <li key={index} className="list-item">
                <span className="arrow-icon">➔</span>
                <a
                  href={doc.url}
                  className="document-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {doc.text}
                </a>
              </li>
            ))}
          </ul>

          {}
          <div className="legal-note">
            <strong>NOTE:</strong> The schools needs to upload the self attested
            copies of above listed documents by chairman/ manager/ secretary and
            principal. in case, it is noticed at later stage that uploaded
            documents are not genuine then school shall be liable for action as
            per norms.
          </div>
        </section>

        <hr className="section-divider" />

        {}
        <section className="disclosure-section">
          <h2 className="section-title">Results and Academics</h2>
          <ul className="links-list">
            {academicsList.map((academic, index) => (
              <li key={index} className="list-item">
                <span className="arrow-icon">➔</span>
                <a
                  href={academic.url}
                  className="document-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {academic.text}
                </a>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default DocumentsAndAcademics;
